export default "__VITE_ASSET__ade361da__"